<template>
    <div class="coin-record">
        <div class="record-header">{{ name }}</div>
        <div class="coin-record-tabs">
            <span :class="{ active: isActive === 1 }" @click="isActive = 1" v-if="isShowCoinHistory">
                <svg class="icon" aria-hidden="true" style="margin-right: 5px">
                    <use xlink:href="#iconjinbi" />
                </svg>
                金幣
            </span>
            <span class="line" v-if="isShowDiamondHistory && isShowCoinHistory"></span>
            <span :class="{ active: isActive === 2 }" @click="isActive = 2" v-if="isShowDiamondHistory">
                <svg class="icon" aria-hidden="true" style="margin-right: 5px">
                    <use xlink:href="#iconzuanshi" />
                </svg>
                鑽石
            </span>
        </div>
        <div class="tab-content">
            <!-- 金幣 -->
            <div class="coin" v-show="isActive === 1">
                <!-- 查詢 -->
                <div class="search-condition">
                    <el-select v-model="recordType" placeholder="記錄類型">
                        <el-option v-for="item in recordTypeOptions" :key="item.dictionaryNameWithCulture" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
                    </el-select>
                    <!-- <el-input v-model="operator" placeholder="操作人" suffix-icon="el-icon-search"></el-input> -->
                    <span class="gap">時間：</span>
                    <el-date-picker v-model="startDate" align="right" type="date" placeholder="選擇日期" :picker-options="pickerOptions" value-format="timestamp" @change="pickDate"></el-date-picker>
                    <span class="gap">—</span>
                    <el-date-picker v-model="endDate" align="right" type="date" placeholder="選擇日期" :picker-options="endDatePickerOptions" value-format="timestamp" @change="pickDateEnd"></el-date-picker>
                    <el-button type="danger" @click="search" class="ml-25">搜尋</el-button>
                    <el-button type="info" @click="reset">重置</el-button>
                    <el-button type="info" @click="downloadExl">導出</el-button>
                </div>
                <!-- 表格 -->
                <div class="table-contain">
                    <el-table :data="tableData" empty-text="暫無數據" style="width: 100%" v-loading="loading">
                        <!-- <el-table-column prop="createTime" label="編號"></el-table-column> -->
                        <el-table-column label="時間">
                            <template slot-scope="scope">
                                {{ scope.row.createTime | initTime | getTime }}
                                {{ scope.row.createTime | initTime | getDateTime }}
                            </template>
                        </el-table-column>
                        <el-table-column v-if="type === 'department'" prop="organizationCoinTransWithCulture" label="類型"></el-table-column>
                        <el-table-column v-else prop="userCoinRecordWithCulture" label="類型"></el-table-column>
                        <el-table-column prop="sourceName" label="轉出組別/人">
                            <template slot-scope="scope">{{ scope.row.sourceName.trim().length === 0 ? '-' : scope.row.sourceName }}</template>
                        </el-table-column>
                        <el-table-column prop="receiveName" label="轉入組別/人">
                            <template slot-scope="scope">{{ scope.row.receiveName.trim().length === 0 ? '-' : scope.row.receiveName }}</template>
                        </el-table-column>
                        <el-table-column prop="propertyCoin" label="金幣">
                            <template slot-scope="scope">
                                <span v-if="type === 'staff'" :class="color(scope.row.userCoinRecord)">{{ scope.row.userCoinRecord | addSymbolStaff }}{{ scope.row.propertyCoin }}</span>
                                <span v-if="type === 'department'" :class="color(scope.row.organizationCoinTrans)">{{ scope.row.organizationCoinTrans | addSymbolDepartment }}{{ scope.row.propertyCoin }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="operatorName" label="操作人"></el-table-column>
                    </el-table>
                    <div class="pagination clearfix">
                        <div class="count" v-if="false">
                            <span>當前查詢記錄：{{ total }}</span>
                            <span>總記錄：{{ totalCount }}</span>
                        </div>
                        <el-pagination background :current-page.sync="currentPage" :page-size="pageCount" :page-sizes="[10, 20, 50, 100]" layout="total,sizes, prev, pager,next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
                    </div>
                </div>
            </div>
            <!-- 磚石 -->
            <div class="diamond" v-show="isActive === 2">
                <!-- 查詢 -->
                <div class="search-condition">
                    <el-select v-model="recordType" placeholder="記錄類型">
                        <el-option v-for="item in recordTypeOptions" :key="item.dictionaryNameWithCulture" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
                    </el-select>
                    <!-- <el-input v-model="operator" placeholder="操作人" suffix-icon="el-icon-search"></el-input> -->
                    <span class="gap">時間：</span>
                    <el-date-picker v-model="startDate" align="right" type="date" placeholder="選擇日期" :picker-options="pickerOptions" value-format="timestamp" @change="pickDate"></el-date-picker>
                    <span class="gap">—</span>
                    <el-date-picker v-model="endDate" align="right" type="date" placeholder="選擇日期" :picker-options="endDatePickerOptions" value-format="timestamp" @change="pickDateEnd"></el-date-picker>
                    <el-button type="danger" @click="searchDiamond" class="ml-25">搜尋</el-button>
                    <el-button type="info" @click="resetDiamond">重置</el-button>
                    <el-button type="info" @click="downloadExl">導出</el-button>
                </div>
                <!-- 表格 -->
                <div class="table-contain">
                    <el-table :data="diamondTableData" empty-text="暫無數據" style="width: 100%" v-loading="daimondLoading">
                        <!-- <el-table-column prop="createTime" label="編號"></el-table-column> -->
                        <el-table-column label="時間">
                            <template slot-scope="scope">
                                {{ scope.row.createTime | initTime | getTime }}
                                {{ scope.row.createTime | initTime | getDateTime }}
                            </template>
                        </el-table-column>
                        <el-table-column v-if="type === 'department'" prop="organizationCoinTransWithCulture" label="類型"></el-table-column>
                        <el-table-column v-else prop="userCoinRecordWithCulture" label="類型"></el-table-column>
                        <el-table-column prop="sourceName" label="轉出組別/人">
                            <template slot-scope="scope">{{ scope.row.sourceName.trim().length === 0 ? '-' : scope.row.sourceName }}</template>
                        </el-table-column>
                        <el-table-column prop="receiveName" label="轉入組別/人">
                            <template slot-scope="scope">{{ scope.row.receiveName.trim().length === 0 ? '-' : scope.row.receiveName }}</template>
                        </el-table-column>
                        <el-table-column prop="propertyCoin" label="鑽石">
                            <template slot-scope="scope">
                                <span v-if="type === 'staff'" :class="color(scope.row.userCoinRecord)">{{ scope.row.userCoinRecord | addSymbolStaff }}{{ scope.row.propertyCoin }}</span>
                                <span v-if="type === 'department'" :class="color(scope.row.organizationCoinTrans)">{{ scope.row.organizationCoinTrans | addSymbolDepartment }}{{ scope.row.propertyCoin }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="operatorName" label="操作人"></el-table-column>
                    </el-table>
                    <div class="pagination clearfix">
                        <div class="count" v-if="false">
                            <span>當前查詢記錄：{{ total }}</span>
                            <span>總記錄：{{ totalCount }}</span>
                        </div>
                        <el-pagination background :current-page.sync="currentPage" :page-size="diamondPageCount" :page-sizes="[10, 20, 50, 100]" layout="total,sizes, prev, pager,next, jumper" :total="diamonddTotal" @size-change="handleDiamondSizeChange" @current-change="handleDiamondCurrentChange"></el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
    name: 'recordDetail',
    data() {
        function getOneMonth() {
            const date = new Date();
            return date.setTime(date.getTime() - 3600 * 1000 * 24 * 31);
        }
        return {
            companyType:0,
            accountType:false,
            isUsedDiamond: false,
            isShowDiamondHistory: false,
            isShowCoinHistory: false,
            isActive: 1,
            loading: false,
            departmentId: 0, // 当前组织id
            name: '', // 当前组织或员工姓名
            type: '', // 员工还是组织，
            accountId: 0,
            recordType: '',
            recordTypeOptions: [],
            organizationTypeOptions: [
                // {
                //     label: '充值金幣',
                //     value: 'recharge'
                // },
                // {
                //     label: '730存入',
                //     value: 'usageItemDictionary'
                // },
                // {
                //     label: '730回收',
                //     value: 'UsageItemDictionaryReturn'
                // },
                // {
                //     label: '上級組別轉入',
                //     value: 'superiorToSelf'
                // },
                // {
                //     label: '上級組別回收',
                //     value: 'superiorBackSelf'
                // },
                // {
                //     label: '分配給員工',
                //     value: 'selfToUser'
                // },
                // {
                //     label: '回收员工',
                //     value: 'selfBackUser'
                // },
                // {
                //     label: '分配下級組別',
                //     value: 'selfToLower'
                // },
                // {
                //     label: '回收下級組別',
                //     value: 'selfBackLower'
                // }
            ],
            staffTypeOptions: [
                // {
                //     label: '被分配金幣',
                //     value: 'organizationToUser'
                // },
                // {
                //     label: '回收金幣',
                //     value: 'userToOrganization'
                // },
                // {
                //     label: '刊登樓盤',
                //     value: 'property'
                // }
            ],
            // operator: "",
            // startDate: getOneMonth(),
            // startDate:new Date(new Date().setHours(0, 0, 0, 0)),
            startDate: '',
            // endDate: new Date().getTime(),
            endDate: new Date().getTime(),
            pickerOptions: {
                disabledDate: time => {
                    if (this.endDate) {
                        return time.getTime() > this.endDate;
                    } else {
                        return time.getTime() > new Date().getTime();
                    }
                }
            },
            endDatePickerOptions: {
                disabledDate: time => {
                    // console.log(this.startDate);
                    if (this.startDate) {
                        return time.getTime() < this.startDate || time.getTime() > new Date().getTime();
                    } else {
                        return time.getTime() > new Date().getTime();
                    }
                }
            },
            tableData: [],
            total: 0,
            totalCount: 0,
            pageIndex: 1,
            currentPage: 1,
            pageCount: 10,
            /* 砖石记录 */
            daimondLoading: false,
            currentDiamond: 0,
            diamondTableData: [],
            diamonddTotal: 0,
            daimondPageIndex: 1,
            diamondPageCount: 10
        };
    },
    created() {
        // 将日期改为最近30天(页面初次进入时间也需要显示)
        this.startDate = new Date(new Date().setHours(0, 0, 0, 0));
        // this.startDate.setDate(this.startDate.getDate()- 29)
        this.startDate.setDate(this.startDate.getDate() - 364);
        this.getCompanyCofig();
        this.departmentId = this.$route.query.departmentId;
        this.name = this.$route.query.name;
        this.type = this.$route.query.type;
        this.accountId = this.$route.query.accountId;
        // this.searchUserCoinRecord();
        // if (this.type === 'staff') {
        //     this.recordTypeOptions = this.staffTypeOptions;
        //     this.accountId = this.$route.query.accountId;
        // } else {
        //     this.recordTypeOptions = this.organizationTypeOptions;
        // }
        this.getRecordTypes();
        this.getTableList();
    },
    methods: {
        addSymbolStaffs(val) {
            if (val === 1 || val === 2 || val === 12 || val === 4) return '-';
        },
        addSymbolDepartments(val) {
            if (val === 2 || val === 4 || val === 5 || val === 7 || val === 10 || val === 12) return '-';
        },
        //金币
        async coinExp(data = {}) {
            if (this.type == 'department') {
                let res = await this.axios.post(
                    this.pub.getApi().SearchDepartmentCoinRecord,
                    Object.assign(
                        {
                            departmentID: this.departmentId,
                            pageIndex: 1,
                            pageCount: 50000,
                            startTime: this.startDate / 1000,
                            endTime: this.endDate / 1000
                        },
                        data
                    )
                );
                let { code, result } = res.data;
                if (code === 0) {
                    this.tableDatas = result.record.data;
                }
            } else {
                let res = await this.axios.post(
                    this.pub.getApi().SearchUserCoinRecord,
                    Object.assign(
                        {
                            departmentID: this.departmentId,
                            accountID: this.accountId,
                            pageIndex: 1,
                            pageCount: 50000,
                            startTime: this.startDate / 1000,
                            endTime: this.endDate / 1000
                        },
                        data
                    )
                );
                let { code, result } = res.data;
                if (code === 0) {
                    this.tableDatas = result.record.data;
                }
            }
        },
        //钻石
        async diaExp(data = {}) {
            if (this.type == 'department') {
                let res = await this.axios.post(
                    this.pub.getApi().SearchDepartmentDiamondRecord,
                    Object.assign(
                        {
                            departmentID: this.departmentId,
                            pageIndex: 1,
                            pageCount: 50000,
                            startTime: this.startDate / 1000,
                            endTime: this.endDate / 1000
                        },
                        data
                    )
                );
                let { code, result } = res.data;
                if (code === 0) {
                    this.tableDatas = result.record.data;
                }
            } else {
                let res = await this.axios.post(
                    this.pub.getApi().SearchUserDiamondRecord,
                    Object.assign(
                        {
                            departmentID: this.departmentId,
                            accountID: this.accountId,
                            pageIndex: 1,
                            pageCount: 50000,
                            startTime: this.startDate / 1000,
                            endTime: this.endDate / 1000
                        },
                        data
                    )
                );
                let { code, result } = res.data;
                if (code === 0) {
                    this.tableDatas = result.record.data;
                }
            }
        },
        async downloadExl() {
            const loading = this.$loading({
                lock: true,
                text: '正在努力導出數據,大約會耗時幾分鐘，請不要關閉當前網頁',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            if (this.isActive == 1) {
                // 金币
                await this.coinExp();
            } else {
                await this.diaExp();
            }
            if (!this.tableDatas) return;
            if (this.isActive == 1) {
                // 金币
                await this.coinExp();
                var header = { header: ['時間', '類型', '轉出組別/人', '轉入組別/人', '金幣', '操作人'] };
            } else {
                await this.diaExp();
                var header = { header: ['時間', '類型', '轉出組別/人', '轉入組別/人', '鑽石', '操作人'] };
            }
            var arr = [];
            // 个人和组别的金币钻石不同 filter
            if (this.isActive == 1) {
                if (this.type === 'department') {
                    if (this.tableDatas) {
                        this.tableDatas.map(item => {
                            let a = this.addSymbolDepartments(item.organizationCoinTrans);
                            let obj = {};
                            obj.時間 = item.createTimeStr;
                            obj.類型 = item.organizationCoinTransWithCulture;
                            // obj.轉出組別 = item.sourceName;
                            // obj.轉入組別 = item.receiveName;
                            obj['轉出組別/人'] = item.sourceName;
                            obj['轉入組別/人'] = item.receiveName;
                            // obj.金幣 = `${a}${item.propertyCoin}`;
                            if (a == '-') {
                                obj.金幣 = parseInt(`${a}${item.propertyCoin}`);
                            } else {
                                obj.金幣 = parseInt(item.propertyCoin);
                            }
                            obj.操作人 = item.operatorName;

                            arr.push(obj);
                        });
                    }
                } else {
                    if (this.tableDatas) {
                        this.tableDatas.map(item => {
                            let a = this.addSymbolStaffs(item.userCoinRecord);
                            let obj = {};
                            obj.時間 = item.createTimeStr;
                            obj.類型 = item.userCoinRecordWithCulture;
                            obj['轉出組別/人'] = item.sourceName;
                            obj['轉入組別/人'] = item.receiveName;
                            // obj.金幣 = `${a}${item.propertyCoin}`;
                            if (a == '-') {
                                obj.金幣 = parseInt(`${a}${item.propertyCoin}`);
                            } else {
                                obj.金幣 = parseInt(item.propertyCoin);
                            }
                            obj.操作人 = item.operatorName;

                            arr.push(obj);
                        });
                    }
                }
            } else {
                if (this.type === 'department') {
                    if (this.tableDatas) {
                        this.tableDatas.map(item => {
                            let a = this.addSymbolDepartments(item.organizationCoinTrans);
                            let obj = {};
                            obj.時間 = item.createTimeStr;
                            obj.類型 = item.organizationCoinTransWithCulture;
                            obj['轉出組別/人'] = item.sourceName;
                            obj['轉入組別/人'] = item.receiveName;
                            // obj.鑽石 = `${a}${item.propertyCoin}`;
                            if (a == '-') {
                                obj.鑽石 = parseInt(`${a}${item.propertyCoin}`);
                            } else {
                                obj.鑽石 = parseInt(item.propertyCoin);
                            }
                            obj.操作人 = item.operatorName;

                            arr.push(obj);
                        });
                    }
                } else {
                    if (this.tableDatas) {
                        this.tableDatas.map(item => {
                            let a = this.addSymbolStaffs(item.userCoinRecord);
                            let obj = {};
                            obj.時間 = item.createTimeStr;
                            obj.類型 = item.userCoinRecordWithCulture;
                            obj['轉出組別/人'] = item.sourceName;
                            obj['轉入組別/人'] = item.receiveName;
                            // obj.鑽石 = `${a}${item.propertyCoin}`;
                            if (a == '-') {
                                obj.鑽石 = parseInt(`${a}${item.propertyCoin}`);
                            } else {
                                obj.鑽石 = parseInt(item.propertyCoin);
                            }
                            obj.操作人 = item.operatorName;

                            arr.push(obj);
                        });
                    }
                }
            }
            const ws = XLSX.utils.json_to_sheet(arr, header);
            const wb = XLSX.utils.book_new();
            if (this.isActive == 1) {
                XLSX.utils.book_append_sheet(wb, ws, 'PMS金幣記錄');
                XLSX.writeFile(wb, 'PMS金幣記錄.xlsx');
            } else {
                XLSX.utils.book_append_sheet(wb, ws, 'PMS鑽石記錄');
                XLSX.writeFile(wb, 'PMS鑽石記錄.xlsx');
            }
            loading.close();
        },
        // 获取公司配置
        getCompanyCofig() {
            this.axios.get(this.pub.getApi().GetCompanyCofig).then(res => {
                // console.log(res,'配置');
                if (res.data.code === 0 && res.data.result) {
                    // 1 中原，2 利嘉阁 3 其他公司
                    this.isProhibitBuyCoin = res.data.result.isProhibitBuyCoin;
                    this.isUsedDiamond = res.data.result.isUsedDiamond;
                    this.isShowDiamondHistory = res.data.result.isShowDiamondHistory;
                    this.isShowCoinHistory = res.data.result.isShowCoinHistory;
                    this.accountType= res.data.result.accountType
                    this.companyType = res.data.result.companyType
                    // 判断其是否启用钻石或者金币
                    if (!(this.isShowDiamondHistory && this.isShowCoinHistory) && this.isShowDiamondHistory) {
                        setInterval(() => {
                            this.isActive = 2;
                        }, 200);
                    }
                }
            });
        },
        /* 獲取記錄類型 */
        async getRecordTypes() {
            let res = await this.axios.get(this.pub.getApi().SearchDictionaryInfo);
            if (res.data.code === 0 && res.data.result) {
                //   console.log(res.data.result,'字典數據')
                res.data.result.forEach(ele => {
                    if (ele.itemName === 'OrganizationCoinTrans') {
                        //   console.log(ele,'組別')
                        this.organizationTypeOptions = this.handleRecordType(ele).filter(item => {
                            return item.dictionaryNameWithCulture != '全部收入' && item.dictionaryNameWithCulture != '全部支出';
                        });
                        //   console.log(this.handleRecordType(ele))
                    }
                    if (ele.itemName === 'UserCoinRecord') {
                        this.staffTypeOptions = this.handleRecordType(ele).filter(item => {
                            return item.dictionaryNameWithCulture != '全部收入' && item.dictionaryNameWithCulture != '全部支出';
                        });
                        //   console.log(ele,'個人')
                    }
                });
                if (this.type === 'staff' && this.isActive === 1) {
                    this.recordTypeOptions = this.staffTypeOptions;
                    this.companyType == 2?this.recordTypeOptions = this.recordTypeOptions.filter(item => item.dictionaryValue != 'Coupon'):this.recordTypeOptions
                }
                if (this.type === 'department' && this.isActive === 1) {
                    this.recordTypeOptions = this.organizationTypeOptions.filter(item => item.dictionaryValue != 'RechargeDiamond');
                    this.companyType == 2?this.recordTypeOptions = this.organizationTypeOptions.filter(item => item.dictionaryValue != 'Coupon'):this.recordTypeOptions
                }
                if (this.type === 'department' && this.isActive === 2) {
                    this.recordTypeOptions = this.organizationTypeOptions.filter(item => item.dictionaryValue != 'Recharge');
                    this.companyType == 2?this.recordTypeOptions = this.recordTypeOptions.filter(item => item.dictionaryValue != 'Coupon'):this.recordTypeOptions

                }
            }
        },
        /* 類型數據處理 */
        handleRecordType(obj) {
            let data = [];
            if (obj.children && obj.children.length > 0) {
                obj.children.forEach(item => {
                    let result = this.handleRecordType(item);
                    data = data.concat(result);
                });
            } else {
                data = data.concat(obj);
            }
            return data;
        },
        // 查找组织金币记录
        async searchDepartmentCoinRecord(data = {}) {
            this.loading = true;
            let res = await this.axios.post(
                this.pub.getApi().SearchDepartmentCoinRecord,
                Object.assign(
                    {
                        departmentID: this.departmentId,
                        startTime: this.startDate / 1000,
                        endTime: this.endDate / 1000,
                        pageIndex: this.pageIndex,
                        pageCount: this.pageCount
                    },
                    data
                )
            );
            // console.log("deparment", res);
            this.loading = false;
            let { code, result, message } = res.data;
            if (code === 0) {
                this.total = result.record.count;
                this.tableData = result.record.data;
                if (Object.keys(data).length === 0) {
                    this.totalCount = result.record.count;
                }
            }
        },
        // 查询组织下员工金币记录
        async searchStaffRecord(data = {}) {
            this.loading = true;
            let res = await this.axios.post(
                this.pub.getApi().SearchUserCoinRecord,
                Object.assign(
                    {
                        departmentID: this.departmentId,
                        accountID: this.accountId,
                        startTime: this.startDate / 1000,
                        endTime: this.endDate / 1000,
                        pageIndex: this.pageIndex,
                        pageCount: this.pageCount
                    },
                    data
                )
            );
            this.loading = false;
            // console.log("userRecord", res);
            let { code, result, message } = res.data;
            if (code === 0) {
                this.total = result.record.count;
                this.tableData = result.record.data;
                if (Object.keys(data).length === 0) {
                    this.totalCount = result.record.count;
                }
            }
        },
        // 获取列表
        getTableList() {
            if (this.type === 'staff') {
                let data = {};
                if (this.recordType) data.userCoinRecord = this.recordType;
                this.searchStaffRecord(data);
            } else {
                let data = {};
                if (this.recordType) data.organizationCoinTrans = this.recordType;
                this.searchDepartmentCoinRecord(data);
            }
        },
        search() {
            if (!this.endDate || !this.startDate) {
                this.$message({
                    message: '請選擇日期',
                    type: 'error',
                    showClose: true
                });
                return;
            }
            let tewMonth = 3600 * 1000 * 24 * 30 * 12 + 5 * 3600 * 1000 * 24;
            if (this.endDate - this.startDate > tewMonth) {
                this.$message({
                    message: '最長週期為365天',
                    type: 'error',
                    showClose: true
                });
                return;
            }

            this.pageIndex = 1;
            this.currentPage = 1;

            this.getTableList();
        },
        reset() {
            this.recordType = '';
            // this.startDate = new Date(new Date().setHours(0, 0, 0, 0));
            this.startDate = new Date(new Date().setHours(0, 0, 0, 0));
            // this.startDate.setDate(this.startDate.getDate()- 29)
            this.startDate.setDate(this.startDate.getDate() - 364);

            this.endDate = new Date().getTime();
            this.pageIndex = 1;
            this.getTableList();
        },
        handleSizeChange(val) {
            this.pageCount = val;
            this.pageIndex = 1;
            this.getTableList();
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            // console.log(val);
            this.getTableList();
        },
        getOneMonth() {
            const date = new Date();
            return date.setTime(date.getTime() - 3600 * 1000 * 24 * 31);
        },
        pickDate(date) {
            // console.log(date);
            if (!date) return;
            let tewMonth = 3600 * 1000 * 24 * 30 * 12 + 5 * 3600 * 1000 * 24;
            if (this.endDate - date > tewMonth) {
                this.$message({
                    message: '最長週期為365天',
                    type: 'error',
                    showClose: true
                });
                return;
            }
        },
        pickDateEnd(date) {
            // console.log(date);
            if (!date) return;
            let tewMonth = 3600 * 1000 * 24 * 30 * 12 + 5 * 3600 * 1000 * 24;
            if (date - this.startDate > tewMonth) {
                this.$message({
                    message: '最長週期為365天',
                    type: 'error',
                    showClose: true
                });
                return;
            }
            // 只要改变了 所有的endtime 都加时间
            this.endDate = this.endDate + 86399000;
        },
        color(val) {
            if (this.type === 'staff') {
                if (val === 1 || val === 2 || val === 4 ) return 'red';
                if (val === 0 || val === 3 || val === 12) return 'green';
            } else {
                if (val === 2 || val === 4 || val === 5 || val === 7 || val === 10 || val === 12) return 'red';
                if (val === 0 || val === 1 || val === 3 || val === 6 || val === 8 || val === 9 || val === 11) return 'green';
            }
        },
        /* 组织砖石记录 */
        async searchDepartmentDiamondRecord(data = {}) {
            this.daimondLoading = true;
            let res = await this.axios.post(
                this.pub.getApi().SearchDepartmentDiamondRecord,
                Object.assign(
                    {
                        departmentID: this.departmentId,
                        pageIndex: this.daimondPageIndex,
                        pageCount: this.diamondPageCount,
                        startTime: this.startDate / 1000,
                        endTime: this.endDate / 1000
                    },
                    data
                )
            );
            this.daimondLoading = false;
            // console.log("userRecord", res);
            let { code, result, message } = res.data;
            if (code === 0) {
                this.diamonddTotal = result.record.count;
                this.diamondTableData = result.record.data;
                this.currentDiamond = result.currentCoin;
            }
        },
        /* 获取当前人的砖石记录 */
        async searchUserDiamondRecord(data = {}) {
            this.daimondLoading = true;
            let res = await this.axios.post(
                this.pub.getApi().SearchUserDiamondRecord,
                Object.assign(
                    {
                        departmentID: this.departmentId,
                        accountID: this.accountId,
                        pageIndex: this.daimondPageIndex,
                        pageCount: this.diamondPageCount,
                        startTime: this.startDate / 1000,
                        endTime: this.endDate / 1000
                    },
                    data
                )
            );
            this.daimondLoading = false;
            // console.log("userRecord", res);
            let { code, result, message } = res.data;
            if (code === 0) {
                this.diamonddTotal = result.record.count;
                this.diamondTableData = result.record.data;
                this.currentDiamond = result.currentCoin;
            }
        },
        getDiamonList() {
            if (this.type === 'staff') {
                let data = {};
                if (this.recordType) data.userCoinRecord = this.recordType;
                this.searchUserDiamondRecord(data);
            } else {
                let data = {};
                if (this.recordType) data.organizationCoinTrans = this.recordType;
                this.searchDepartmentDiamondRecord(data);
            }
        },
        searchDiamond() {
            if (!this.endDate || !this.startDate) {
                this.$message({
                    message: '請選擇日期',
                    type: 'error',
                    showClose: true
                });
                return;
            }
            let tewMonth = 3600 * 1000 * 24 * 30 * 12 + 5 * 3600 * 1000 * 24;
            if (this.endDate - this.startDate > tewMonth) {
                this.$message({
                    message: '最長週期為365天',
                    type: 'error',
                    showClose: true
                });
                return;
            }
            this.daimondPageIndex = 1;
            this.currentPage = 1;
            let data = {};
            if (this.recordType) {
                data.userCoinRecord = this.recordType;
            }
            this.getDiamonList(data);
        },
        resetDiamond() {
            this.recordType = '';
            // this.startDate = new Date(new Date().setHours(0, 0, 0, 0));
            this.startDate = new Date(new Date().setHours(0, 0, 0, 0));
            //this.startDate.setDate(this.startDate.getDate()- 29)
            this.startDate.setDate(this.startDate.getDate() - 364);

            this.endDate = new Date().getTime();
            this.daimondPageIndex = 1;
            this.getDiamonList();
        },
        handleDiamondSizeChange(val) {
            this.diamondPageCount = val;
            this.daimondPageIndex = 1;
            this.getDiamonList();
        },
        handleDiamondCurrentChange(val) {
            this.daimondPageIndex = val;
            this.getDiamonList();
        }
    },
    filters: {
        initTime(t) {
            let time = t.split(/[-T:]/);
            let [year, month, day, hours = 0, minutes = 0, seconds = 0] = time;
            let currentTime = new Date(year, month - 1, day, hours, minutes, seconds);
            return Math.round(currentTime.getTime() / 1000);
        },
        addSymbolStaff(val) {
            if (val === 1 || val === 2 || val === 12 || val === 4) return '-';
            if (val === 0 || val === 3) return '+';
        },
        addSymbolDepartment(val) {
            // if (val === 3 || val === 4 || val === 6) return '-';
            // if (val === 0 || val === 1 || val === 2 || val === 5 || val === 7) return '+';
            if (val === 2 || val === 4 || val === 5 || val === 7 || val === 10 || val === 12) return '-';
            if (val === 0 || val === 1 || val === 3 || val === 6 || val === 8 || val === 9 || val === 11) return '+';
        }
    },
    computed: {
        /* 金币组织记录类型 */
        coinOrganizationTypeOptions() {
            /* 去掉购买砖石 */
            return this.organizationTypeOptions.filter((item = item.dictionaryValue != 'RechargeDiamond'));
        },
        /*砖石组织记录类型  */
        diamondOrganizationTypeOptions() {
            /* 去掉购买金币 */
            return this.organizationTypeOptions.filter((item = item.dictionaryValue != 'Recharge'));
        }
    },
    watch: {
        isActive(val) {
            console.log('重置数据', val);
            /* 重置数据 */
            this.recordType = '';
            // this.startDate = new Date(new Date().setHours(0, 0, 0, 0));
            // 将日期改为最近30天
            this.startDate = new Date(new Date().setHours(0, 0, 0, 0));
            // this.startDate.setDate(this.startDate.getDate()- 29)
            this.startDate.setDate(this.startDate.getDate() - 364);

            this.endDate = new Date().getTime();
            if (val === 1) {
                /* 金币 */
                (this.pageIndex = 1), this.getTableList();
            } else {
                /* 砖石 */
                this.daimondPageIndex = 1;
                this.getDiamonList();
            }
            if (this.type === 'department' && val === 1) {
                this.recordTypeOptions = this.organizationTypeOptions.filter(item => item.dictionaryValue != 'RechargeDiamond');
                this.companyType == 2?this.recordTypeOptions.filter(item => item.dictionaryValue != 'Coupon'):this.recordTypeOptions
            }
            if (this.type === 'department' && val === 2) {
                this.recordTypeOptions = this.organizationTypeOptions.filter(item => item.dictionaryValue != 'Recharge');
                this.companyType == 2?this.recordTypeOptions.filter(item => item.dictionaryValue != 'Coupon'):this.recordTypeOptions
            }
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../../assets/css/element-reset.less';
.coin-record {
    text-align: left;
    box-sizing: border-box;
    .record-header {
        font-size: 24px;
        margin-bottom: 24px;
        color: #171725;
    }
    .coin-record-tabs {
        margin-bottom: 20px;
        span {
            display: inline-block;
            // margin-right: 60px;
            font-size: 22px;
            color: #92929d;
            letter-spacing: 0.1px;
            cursor: pointer;
        }
        span.active {
            color: #171725;
        }
        .line {
            width: 1px;
            height: 22px;
            background-color: #979797;
            position: relative;
            top: 3px;
            margin: 0 22px;
        }
    }
    .search-condition {
        border-bottom: 1px solid #e2e2ea;
        padding-bottom: 30px;
        .el-select {
            width: 130px;
            height: 38px;
            margin-right: 15px;
            margin-top: 10px;
            /deep/.el-input__inner {
                background: #ffffff;
                border-radius: 10px;
                height: 38px;
                line-height: 38px;
                border: none;
            }
        }
        .el-input {
            width: 150px;
            /deep/.el-input__inner {
                background: #ffffff;
                border-radius: 10px;
                height: 38px;
                line-height: 38px;
                border: none;
            }
        }
        .el-input + .el-input {
            margin-left: 15px;
            margin-top: 10px;
        }
        // .el-input + span {
        //   margin-right: 10px;
        //   margin-left: 10px;
        // }
        .gap {
            margin-right: 5px;
            margin-left: 5px;
        }
        .el-button {
            width: 88px;
            margin-left: 10px;
            // margin-top: 10px;
            border-radius: 10px;
        }
        .ml-25 {
            margin-left: 25px;
        }
    }
    .table-contain {
        border-radius: 20px;
        padding: 15px 10px;
        background-color: #fff;
        margin-top: 25px;
        .pagination {
            // text-align: center;
            margin-top: 20px;
            line-height: 35px;
            .count {
                float: left;
                span ~ span {
                    margin-left: 10px;
                }
            }
            .el-pagination {
                float: right;
            }
        }
    }
    .red {
        color: #e50113;
    }
    .green {
        color: green;
    }
    .clearfix:after {
        content: '';
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
    }
    .clearfix {
        /* 触发 hasLayout */
        zoom: 1;
    }
}
</style>
